// @ts-nocheck

import { createSelector } from 'reselect';

import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserJwtToken } from '../../selectors/user/userPrimary.selector';
import { type Licence } from '../../types/common';
import { type Selector } from '../../types/selectors';

type UserAccountPropsType = {
  licence: Licence;
  jwt: string;
};

const selectUserAccountProps: Selector<UserAccountPropsType> = createSelector(
  [selectRuntimeLicence, selectUserJwtToken],
  (licence, jwt) => ({
    licence,
    jwt,
  }),
);

export default selectUserAccountProps;
